var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6702 15.529C12.338 15.529 11.0082 15.022 9.99429 14.0082C9.72 13.7339 9.72 13.2857 9.99429 13.009C10.2686 12.7347 10.7167 12.7347 10.9935 13.009C12.4702 14.4857 14.8727 14.4857 16.3494 13.009L21.4824 7.87592C22.9592 6.39918 22.9592 3.99673 21.4824 2.52C20.0057 1.04327 17.6033 1.04327 16.1265 2.52L11.7943 6.8498C11.52 7.12408 11.0718 7.12408 10.7951 6.8498C10.5208 6.57551 10.5208 6.12735 10.7951 5.85061L15.1273 1.52082C17.1551 -0.506939 20.4539 -0.506939 22.4792 1.52082C24.5045 3.54857 24.5069 6.84735 22.4792 8.87265L17.3461 14.0082C16.3322 15.022 15 15.529 13.6702 15.529ZM5.19673 24C3.86449 24 2.53469 23.4931 1.52082 22.4792C-0.506939 20.4514 -0.506939 17.1527 1.52082 15.1273L6.65388 9.99184C8.68163 7.96408 11.9804 7.96408 14.0057 9.99184C14.28 10.2661 14.28 10.7143 14.0057 10.991C13.7314 11.2653 13.2833 11.2653 13.0065 10.991C11.5298 9.51429 9.12735 9.51429 7.65061 10.991L2.52 16.1241C1.04327 17.6008 1.04327 20.0033 2.52 21.48C3.99673 22.9567 6.39918 22.9567 7.87592 21.48L12.2082 17.1478C12.4824 16.8735 12.9306 16.8735 13.2073 17.1478C13.4816 17.422 13.4816 17.8702 13.2073 18.1469L8.87265 22.4792C7.85878 23.4931 6.52898 24 5.19673 24Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c6f8456314cfcb674a09a1d802ddccb1.svg";
export { ForwardRef as ReactComponent };